import { FC } from 'react'

import './style.scss'
import { FormResponseStatus } from '../../models/Auth.model'
import { Layout } from '../../containers'
import { Title, Text, Card } from '../../components/UI'
import { Modal, useModal } from '../../components/UI/Modal'
import { RegisterForm, RegisterFormSuccess, RegisterFormError } from '../../components'

const RegisterRutPage:FC = ()  => {
  const modal = useModal()

  const onFormSubmitChange = (status: FormResponseStatus, message?: string) => {
    modal.setStatus(status)
    if(message) modal.setMessage(message)
    modal.open()
  }

  return (
    <Layout type="public">
      <div className="container register-wrapper pt-50 pb-70">
        <Title border>Crear nueva cuenta</Title>

        <Text size="14" lineHeight="6" className="lg:fz-16 mt-40">Ingresa los datos requeridos para registrarte en Mi Portal INDISA.</Text>

        <Card showOnly="lg" className="lg:py-70 lg:px-70 mt-50 lg:mt-25">
          <RegisterForm docType={1} onSubmitChange={(status, message) => onFormSubmitChange(status, message)} />
        </Card>
      </div>

      <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
        {modal.status === 'SUCCESS' && <RegisterFormSuccess>Recibirás un correo electrónico de confirmación</RegisterFormSuccess>}
        {modal.status === 'ERROR' && <RegisterFormError message={modal.message} onClick={() => modal.close()}/>}
      </Modal>
    </Layout>
  )
}

export { RegisterRutPage }